import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CheckboxTree from 'react-checkbox-tree';
// import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import _ from 'lodash';
import Select from 'react-select';
import './style/PersonaCreatorViewAttitudeData.css';

class PersonaCreatorViewAttitudeData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: _.isEmpty(props.selectedAttitudinalTemplate)
        ? props.selectedAttitudesList
        : [],
      segmentCount: props.segmentCount,
      expanded: [],
      selctedExpressionObject: props.selectedExpressionObjectData,
      selectedAttitudinal: _.isEmpty(props.selectedAttitudinalTemplate)
        ? ''
        : props.selectedAttitudinalTemplate.label,
    };

    this.onCheck = this._onCheck.bind(this);
    this.onClick = this._onClick.bind(this);
    this.onExpand = this._onExpand.bind(this);
    this.onSegmentCountChange = this._onSegmentCountChange.bind(this);
    this.selectedExpression = this._selectedExpression.bind(this);
    this.removeExpression = this._removeExpression.bind(this);
  }

  componentDidMount() {
    if (this.state.selectedAttitudinal.length === 0) {
      document.getElementsByClassName('Select-clear-zone')[0].style.visibility =
        'hidden';
    }
  }
  _onCheck(checked) {
    this.selectedExpression(checked, this.props.attitudesList);
    this.setState({ checked });
    // Temp Add, Remove it once you start the update attitudinal feature
    if (this.state.selectedAttitudinal.length > 0) {
      this.setState({ selectedAttitudinal: '' });
      this.props.onSelectAttitudinal('');
      document.getElementsByClassName('Select-clear-zone')[0].style.visibility =
        'hidden';
    }
  }

  _onClick(clicked) {
    this.setState({ clicked });
  }

  _onExpand(expanded) {
    this.setState({ expanded });
  }

  _onSegmentCountChange(evt) {
    this.setState({ segmentCount: evt.target.value });
    this.props.onChangeSegmentsCount(evt.target.value);
  }

  _selectedExpression(listOfExpression, attitudesList) {
    const selctedExpressionObject = [];
    listOfExpression.map(expression => {
      const normalizeAttitudesList = _.flatten(
        _.map(_.keys(attitudesList), val => attitudesList[val].children),
      );
      return selctedExpressionObject.push(
        _.find(normalizeAttitudesList, { value: expression }),
      );
    });
    this.setState(
      { selctedExpressionObject },
      this.props.onChangeSelectedAttitudesList(
        listOfExpression,
        selctedExpressionObject,
      ),
    );
  }

  _removeExpression(expressionObject, index) {
    const copyOfselctedExpressionObject = _.clone(
      this.state.selctedExpressionObject,
    );
    const copyOfchecked = _.clone(this.state.checked);
    copyOfchecked.splice(copyOfchecked.indexOf(expressionObject.value), 1);
    copyOfselctedExpressionObject.splice(index, 1);

    this.setState(
      {
        checked: copyOfchecked,
        selctedExpressionObject: copyOfselctedExpressionObject,
      },
      this.props.onChangeSelectedAttitudesList(
        copyOfchecked,
        copyOfselctedExpressionObject,
      ),
    );
  }

  genDropdownData() {
    let i;
    const html = [];
    for (i = 3; i < 10; i += 1) {
      html.push(
        <option key={i} value={i}>
          {i}
        </option>,
      );
    }

    if (this.props.value === -1) {
      html.push(
        <option disabled key="-1" value="-1">
          -
        </option>,
      );
    }

    return html;
  }

  handleChange = selectedOption => {
    if (selectedOption != null) {
      const listOfExpression = [];
      this.setState({ selectedAttitudinal: selectedOption.label });
      this.props.onSelectAttitudinal(selectedOption);
      document.getElementsByClassName('Select-clear-zone')[0].style.visibility =
        '';
      selectedOption.children.map(child => listOfExpression.push(child.value));
      this.setState(
        { selctedExpressionObject: selectedOption.children },
        this.props.onChangeSelectedAttitudesList(
          listOfExpression,
          selectedOption.children,
        ),
      );
      // Temp Add, Remove it once you start the update attitudinal feature
      this.setState({ checked: [] });
    } else {
      const defaultExpressionObject = this.props.defaultExpressionObject;
      const defaultExpression = this.props.defaultExpression;
      this.setState({ selectedAttitudinal: '' });
      this.props.onSelectAttitudinal({});
      document.getElementsByClassName('Select-clear-zone')[0].style.visibility =
        'hidden';
      this.setState(
        { selctedExpressionObject: defaultExpressionObject },
        this.props.onChangeSelectedAttitudesList(
          defaultExpression,
          defaultExpressionObject,
        ),
      );
      // Temp Add, Remove it once you start the update attitudinal feature
      this.setState({ checked: defaultExpression });
    }
  };

  attitueDropdownOptions = () => [...this.props.attitudinalTemplate.map(template => ({
    label:
          template.label.length > 30
            ? template.label.substr(0, 30).concat('...')
            : template.label,
    value:
          template.label.length > 30
            ? template.label.substr(0, 30).concat('...')
            : template.label,
    title: template.label,
    children: template.children,
  })),
  ];

  render() {
    const { checked, expanded, segmentCount, selectedAttitudinal } = this.state;
    const { attitudesList } = this.props;

    return (
      <div className="">
        <div className="large-12 medium-12 small-12 columns persona-cluster-attitude-div">
          <div className="" style={{ marginTop: '2%' }}>
            <span style={{ float: 'left', paddingRight: '3%' }}>
              {' '}
              Max Solution Clusters :{' '}
            </span>
            <select
              id="segment-dropdown"
              value={segmentCount}
              onChange={evt => {
                this.onSegmentCountChange(evt);
              }}
            >
              {this.genDropdownData()}
            </select>
          </div>
          <div
            className="embed-dropdown-field_copy"
            style={{ margin: '-1% 0% 0% 60%' }}
          >
            <Select
              name="attitudinal-dropdown"
              clearable
              searchable
              options={this.attitueDropdownOptions()}
              onChange={val => this.handleChange(val)}
              value={selectedAttitudinal}
              placeholder="Select Your Template"
            />
          </div>
        </div>

        <div className="">
          <div
            className="large-12 medium-12 small-12 columns"
            style={{ marginTop: '2%' }}
          >
            <div className="row persona-cluster-attitudeList-headerdiv">
              <span className="persona-cluster-attitudeList-header-span">
                Clustering Statements
              </span>
            </div>
            <div className="row persona-cluster-attitudeList-childdiv">
              {attitudesList.length > 0 ? (
                <CheckboxTree
                  checked={checked}
                  expanded={expanded}
                  nodes={attitudesList}
                  onCheck={this.onCheck}
                  onExpand={this.onExpand}
                  showNodeTitle="true"
                />
              ) : (
                  'Fetching Data... Please Wait'
                )}
            </div>
          </div>
        </div>

        {this.state.selctedExpressionObject.length > 0 && (
          <div className="">
            <div
              className="large-12 medium-12 small-12 columns"
              style={{ marginTop: '1%' }}
            >
              <div className="row persona-cluster-attitudeList-headerdiv">
                <span className="persona-cluster-attitudeList-header-span">
                  Selected Statements
                </span>
              </div>
              <div className="row persona-cluster-attitudeSelectedList-childdiv">
                {this.state.selctedExpressionObject.map(
                  (selectedData, index) => (<div
                    key={index}
                    style={{ textAlign: 'Left', marginLeft: '1%' }}
                  >
                    {// Temp Add, Remove it once you start the update attitudinal feature
                      this.state.selectedAttitudinal.length === 0 && (
                        <button
                          type="button"
                          className="persona-cluster-attitudeList-close"
                          title="Delete Statement"
                          aria-label="Close"
                          onClick={() =>
                            this.removeExpression(selectedData, index)
                          }
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      )}
                    <span
                      style={{ color: '#91a2b9' }}
                      title={selectedData.title}
                    >
                      {selectedData.label}
                    </span>
                  </div>
                  ),
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

PersonaCreatorViewAttitudeData.defaultProps = {
  attitudesList: [],
};

PersonaCreatorViewAttitudeData.propTypes = {
  segmentCount: PropTypes.number.isRequired,
  attitudesList: PropTypes.arrayOf(),
  selectedAttitudesList: PropTypes.arrayOf(),
  selectedAttitudinalTemplate: PropTypes.shape({}),
  selectedExpressionObjectData: PropTypes.shape({}),
  onSelectAttitudinal: PropTypes.func,
  onChangeSegmentsCount: PropTypes.func,
  onChangeSelectedAttitudesList: PropTypes.func,
  defaultExpressionObject: PropTypes.shape({}),
  defaultExpression: PropTypes.string,
  attitudinalTemplate: PropTypes.arrayOf(),
  value: PropTypes.string,
};
export default PersonaCreatorViewAttitudeData;
